import React, { useState } from "react";
import PageContainer from "../containers/PageContainer";
import ProductDetails from "../containers/ProductDetails";
import { useTranslation } from 'react-i18next';

export default function ProductView(props) {
     const { t } = useTranslation();
    const showTitle = props.showTitle === true;

    return (
        <PageContainer title={showTitle ? t("Product Details") : ""} showPageTitle={showTitle} showShopToolbar={false}>
            <ProductDetails/>
        </PageContainer>
    );
}
